import { render } from "./CustomerView.vue?vue&type=template&id=5e52e0f2&scoped=true&ts=true"
import script from "./CustomerView.vue?vue&type=script&lang=ts"
export * from "./CustomerView.vue?vue&type=script&lang=ts"

import "./CustomerView.vue?vue&type=style&index=0&id=5e52e0f2&lang=scss&scoped=true"

import exportComponent from "E:\\leilongObject\\庆亚\\qingya_v3\\qingya_v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e52e0f2"]])

export default __exports__